import { Component } from '@angular/core';

import { TableCellState } from '../../table.state';

@Component({
  selector: 'app-cell-user-info',
  templateUrl: './cell-user-info.component.html',
  styleUrls: ['./cell-user-info.component.scss'],
})
export class CellUserInfoComponent extends TableCellState {}
